import React, { Component } from "react";
import { getItemTypes } from "../../actions/jobs";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { required } from "../validators";
import VerticalSelectField from "./VerticalSelectField";
import PropTypes from "prop-types";

class JobItemTypeSelect extends Component {
  componentDidMount() {
    this.props.getItemTypes();
  }
  render() {
    const items = this.props.jobItems.getItemTypes[0];
    return (
      <Field
        component={VerticalSelectField}
        name="item.type"
        label="Type*"
        validate={[required]}
      >
        <option value=""></option>
        {items && items.map((item, index) => <option key={`${index}-${item.code}`} value={item.code}>{item.description}</option>)}
      </Field>
    )
  }
}

const mapStateToProps = (state) => ({ jobItems: state.jobItems });

JobItemTypeSelect.propTypes = {
  getItemTypes: PropTypes.func.isRequired
};

export default connect(mapStateToProps, { getItemTypes })(JobItemTypeSelect);


// WEBPACK FOOTER //
// ./src/forms/fields/JobItemTypeSelect.js